// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_2rBfF","top-info":"top-info_7XkGR","g-item":"g-item","g-count":"g-count","g-text":"g-text"};